import { configureValidationRuntime } from "./validation-runtime";

configureValidationRuntime();

void import("./application.js").catch((error: unknown) => {
  console.error("Dashboard failed to start", error);
  const root = document.getElementById("root");
  if (root) {
    root.textContent = "Jennifer's dashboard could not start. Refresh the page to try again.";
  }
});
